export default function isFunction(value) {
    return value instanceof Function;
}
